import React from 'react'
import SelectorElement from '../../components/SelectElement'
import CardElement from '../../components/card.v2'
import { useFormikContext } from 'formik'
import { LayoutWithAvatar } from '../gender/gender'
import { HoverBorderGradientDemo } from '../../components/Button'

const Region = ({ currentStep, setCurrentStep }) => {
  const { values, setFieldValue } = useFormikContext()
  const handleInputChange = (value) => {
    setFieldValue(`region`, value) // Update userData dynamically
  }

  return (
    <LayoutWithAvatar>
      <div className='col-span-2 max-w-sm mx-auto md:col-span-1 flex items-center gap-20 justify-center'>
        <CardElement>
          <h2 className='text-gray-700 font-semibold mb-4 cursor-pointer'>
            <svg
              onClick={() => {
                setCurrentStep(currentStep - 1)
              }}
              xmlns='http://www.w3.org/2000/svg'
              fill='none'
              viewBox='0 0 24 24'
              strokeWidth='2'
              stroke='currentColor'
              className='w-5 h-5'
            >
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                d='M15 19l-7-7 7-7'
              />
            </svg>
          </h2>
          <img
            src='images/map.svg' // Replace with actual robot image URL
            alt='Robot'
            className='w-full hidden md:block'
          />
          <h2 className='text-gray-700 mt-4 font-semibold text-lg'>
            Receptionist Region:
          </h2>
          <div className='flex flex-col py-3 gap-7 max-h-[170px] px-6 -mx-6 custom-scrollbar overflow-auto'>
            <SelectorElement
              label={'South America'}
              active={values.region == 'South America'}
              onChange={handleInputChange}
            />
            <SelectorElement
              label={'North America'}
              active={values.region == 'North America'}
              onChange={handleInputChange}
            />

            <SelectorElement
              label={'Australia'}
              active={values.region == 'Australia'}
              onChange={handleInputChange}
            />
            <SelectorElement
              label={'Europe'}
              active={values.region == 'Europe'}
              onChange={handleInputChange}
            />
          </div>

          {/* Button */}
          <div className='mt-8'>
            <HoverBorderGradientDemo
              type='button'
              onClick={() => {
                setCurrentStep(currentStep + 1)
              }}
              disabled={!values?.gender}
            >
              <span className='font-bold capitalize'>Select</span>
            </HoverBorderGradientDemo>
          </div>
        </CardElement>
      </div>

      <div className='col-span-1  hidden md:block relative'>
        <div className='relative flex justify-center'>
          <div>
            <video
              src={`/videos/2nd-female.webm`}
              style={{
                filter: values.gender == 'Female' ? '' : 'hue-rotate(270deg)',
              }}
              autoPlay
              loop
              className='w-full h-full'
            />
          </div>
        </div>
      </div>
    </LayoutWithAvatar>
  )
}

export default Region
